export enum SubscriptionTypes {
    standard = 'standard',
    professional = 'professional',
    enterprise = 'enterprise',
    free = 'free',
}